import PdfGenerator from './PdfGenerator';

class Attivita extends PdfGenerator {

    constructor(){
        super();
        this.doDrawCell = this.doDrawCell.bind(this);
        this.doDrawRow = this.doDrawRow.bind(this);
    }

    doDrawCell(cell, data){
        if (data.row.raw.id === ''){
            // Riga dei totali
            cell.styles.fontStyle = 'bold';
            cell.styles.fillColor = [255,255,255];
        }
        else
        {
            if (data.column.dataKey === 'colore'){
                cell.styles.textColor = cell.raw;
            }
        }
    }

    doDrawRow(row, data){
        let doc = data.doc;
        if (data.row.raw.id === ''){
            doc.setFillColor(0);
            doc.rect(data.settings.margin.left, row.y, data.table.width, 1 , 'F');
            data.cursor.y += 1;
        }
    }
}

export default Attivita;


/** WEBPACK FOOTER **
 ** ./src/pdf/Attivita.js
 **/